import { useAppSelector } from 'app/redux/store';
import { AppSettings } from 'core/AppSettings';

export const useCanChangeFacility = () => {
  const { accessibleFacilities } = useAppSelector(state => state.profile.user);
  if (!accessibleFacilities) return false;
  if (AppSettings.isCommunity) return false;
  return accessibleFacilities.length > 1;
};
